<template>
  <b-modal
    id="schedule-modal"
    :size="show || !reSched ? 'lg' : 'md'"
    :title-html="'<i class=\'uil-schedule text-primary\'></i> '+(reSched == true ? 'Reschedule and Suggest availability' : 'Schedule a Candidate')"
    title-class="font-18"
    no-close-on-esc
    no-close-on-backdrop
    centered
    body-class="bg-white py-none"
    static
    :ok-title-html="'<i class=\'uil-check\'></i>' + (reSched == true ? 'SUGGEST OR RESCHEDULE' : 'SET SCHEDULE')"
    ok-variant="danger"
    @ok="onNotifyCandidate"
    button-size= 'sm'
    :cancel-title= "'CANCEL'"
    footer-class= 'p-2'
    hide-header-close
    @show="populateTimes()"
    >
    <div class="text-center loaderko" v-if="loading">
      <div class="spinner-grow text-primary m-2 " role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="text-muted small">Loading</div>
    </div>
    <div v-if="reSched && !show">
      Are you sure you want to proceed or <a href="javascript:void(0)" @click="show=true"> Suggest a Date </a>?
    </div>
    <div v-if="show || !reSched">
      <div class="text-muted py-1 my-3 border-bottom" style="border-bottom: 1px solid #8a8a8a  !important;" v-if="reSched">
      You can proceed without entering your suggested date, just simple click <b>Reschedule Button</b>.</div>
      <div class="row" v-if="!reSched">
        <div class="col-md-12 row">
          <DropDown 
            class="col-md-6"
            placeholder="Select a Timezone"
            label="Timezone"
            :name.sync="timezone"
            v-model="timezone"
            :options="timezone_option" 
          />
          <DropDown 
            class="col-md-6"
            placeholder="Choose a Language"
            label="Language"
            :name.sync="lang"
            v-model="lang"
            :options="lang_option" 
          />
        </div>
        <div class="row col-md-12">
          <TextField
            class="col-md-6"
            label="Location"
            placeholder="Enter Location or link"
            :name.sync="location"
            v-model="location"
          />
          <TextField
            class="col-md-6"
            label="Interview Type"
            placeholder="Enter Type of interview"
            :name.sync="interview_type"
            v-model="interview_type"

          />
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-5 picker-container mb-3">
          <flat-pickr
            v-model="dates"
            class="form-control flatpicker "
            hidden
            ref="pickerdate"
            @on-change="selectDate"
            :config="{inline:true, mode: 'multiple',minDate: 'today'}"
          ></flat-pickr>
        </div>
        <div class="col-md-7">
          <div class="border-bottom mb-2">{{(reSched == true ? 'Suggest a Date and Time' : 'Scheduled Date(s)')}}
            <button class="btn btn-primary btn-xs float-right"
              @click="onClear"
            ><i class="uil-times-circle"></i> Clear All</button>
          </div>
          <VuePerfectScrollbar style="max-height:285px; width:100%;margin-bottom:10px;height: 100%;">
            <div class="h6 text-muted text-center" v-if="times.length == 0">
              <i class="uil-calendar-alt" style="font-size:5rem;"/>
              <div>No date selected</div>
            </div>
            <div class="row py-2"
              v-for="(item, parentIdx) in times"
              :key="item.uiid"
            >
                <div class="h6 mr-3 col-md-12 text-center">
                  <i 
                    class="uil"
                    :class="item._id ? 'uil-schedule' : 'uil-file-plus'" 
                    v-if="item._id"
                  ></i>
                  <span :class="item._id ? 'text-success':'text-danger'"> {{ formatDate(item.date) }} 
                  <div class="badge badge-success" role="button" @click="item.times.push({})"><i class="uil uil-plus"></i> Add Time</div></span>
                </div>

                <div class="media-body col-md-12 mx-3">
                  <div 
                    class="row mb-1"
                    v-for="(_item, idx) in item.times"
                    :key="_item.uiid"
                    >
                    <div class="col-6">
                      <flat-pickr
                        v-model="_item.start_time"
                        class="form-control form-control-md flatpicker"
                        placeholder="Start Time"
                        @input="onChangeStartTime(_item)"
                        :config="{enableTime:true,noCalendar: true,dateFormat: 'h:i K'}"
                      ></flat-pickr>
                    </div>
                    <div class="col-5">
                      <flat-pickr
                        v-model="_item.end_time"
                        class="form-control form-control-md flatpicker"
                        placeholder="End Time"
                        :config="{enableTime:true,noCalendar: true,dateFormat: 'h:i K'}"
                      ></flat-pickr>
                    </div>
                    <div class="col-1 m-auto p-0"><div class="badge badge-danger" role="button" @click="removeTime(item, _item, idx, parentIdx)"><i class="uil uil-trash"></i></div></div>
                  </div>
                </div>
            </div>
          </VuePerfectScrollbar>
        </div>
      </div>
      <hr />
      <div class="my-2" style="height: 100px;
      overflow: hidden;
      overflow-y: scroll;" v-if="stimes.length > 0">
        <h6>Suggested Timeslot by Applicant:</h6>
        <div v-for="time in stimes" :key="time.id">
          <b>{{formatDate(time.date)}}: </b>
          <span class="badge badge-info ml-1 mb-1" style="font-size:14px" v-for="item in time.times" :key="item.id">
            {{item.start_time}} - {{item.end_time}}
          </span>
        </div>
      </div>
    </div>

  </b-modal>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapActions } from 'vuex'
import moment from 'moment/moment'
import  FormMixin from '@mixins/form'
import TextField from '@components/form/textfield.vue'
import DropDown from '@components/form/dropdown.vue'
import timezone from '@src/data/timezone.json'
/* import { authComputed, layoutMethods } from '@state/helpers' */

/**
 * A right sidebar component
 */
export default {
  mixins:[FormMixin],
  components: { VuePerfectScrollbar, TextField, DropDown},
  props: ['title', 'company', 'uiid', 'timesData', 'reSched', 'settings', 'application'],
  data() {
    return {
      show:false,
      timezone:'',
      location:'',
      interview_type:'',
      lang:'jp',
      dates:'',
      timezone_option:timezone,
      lang_option:[
        { value: 'jp', text: 'Japanese'},
        { value: 'us', text: 'English (US)'}
      ],
      times:[],
      stimes:[]
      /* config: {
        handler: this.handleRightBarClick,
        middleware: this.middleware,
        events: ['click'],
      } */
    }
  },
  computed:{
    datesArray(){
      if(this.dates == ''){
        return []
      }
      return this.dates.split(',').map(function(a){return a.trim()}).sort((a, b) => new Date(a) - new Date(b)) || []
    },
    getTimeZone(){
      return this.settings.timezone || null
    }
  },
  methods: {
    ...mapActions('candidate', ['scheduleInterview', 'removeScheduleInterview', 'removeScheduleInterviewByDate', 'saveNotifyCandidate', 'rejectCandidate', 'showResume']),
    /* ...layoutMethods, */
    hide() {
      document.body.classList.toggle('right-bar-enabled')
    },
    onChangeStartTime(item){
      item.end_time = moment(item.start_time, 'hh:mm A').add(1, 'hour').format('hh:mm A')
    },
    populateTimes(){
      this.show = false
      var newTimes = [...this.timesData.resData]
      this.times = []
      for(var key in newTimes){
        newTimes[key]['date'] = moment(newTimes[key]['date']).format('YYYY-MM-DD') 
        newTimes[key]['uiid'] = newTimes[key]['id']
      }
      this.times = newTimes.sort((a, b) => new Date(a.date) - new Date(b.date)) 
      this.dates = newTimes.map(e => e.date).join(", ");
      this.stimes = this.timesData.sugData

      this.timezone= this.getTimeZone

      if(this.application){

        this.timezone = this.application.timezone
        this.location = this.application.location
        this.interview_type = this.application.interview_type
      }
      
    },
    /* handleRightBarClick(e) {
      if (e.target && e.target.classList.contains('rightbar-overlay')){
        this.hide()
      }
    }, */
    middleware(event) {
      return !event.target.classList.contains('toggle-right')
    },
    setTimes(times){
      var newTimes = [...times]
      this.times = []
      for(var key in newTimes){
        newTimes[key]['date'] = moment(newTimes[key]['date']).format('YYYY-MM-DD') 
        newTimes[key]['uiid'] = newTimes[key]['id']
      }
      this.times = newTimes.sort((a, b) => new Date(a.date) - new Date(b.date)) 
      this.dates = newTimes.map(e => e.date).join(", ");
    },
    async removeTime(item, _item, idx, parentIdx){
      if(_item._id){
        await this.removeScheduleInterview(_item)
        this.$bvToast.toast(`Successfully Removed! No need for save.`, {
          title: 'Notification',
          variant:'success'
        })
      }
      console.log(parentIdx);
      item.times.splice(idx, 1)
      if(item.times.length < 1){
        this.times.splice(parentIdx, 1)
        this.dates = this.times.map(e => e.date).join(", ");
      }
    },
    formatDate(value){
      return moment(value).format('YYYY-MM-DD')
    },
    onSubmit(){
      /* this.times = []
      this.dates = ''
      console.log(this.$parent.$data) */

      for(var key in this.times){
        for(var _key in this.times[key]){
          if(!this.times[key][_key]['start_time'] || !this.times[key][_key]['end_time']){
            alert('Please fill up missing fields (Either missing Start time or End time)')
            return false
          }
        }
      }

      if(this.times.length == 0){
        alert('Please add date')
        return false
      }

      this.$bvModal.msgBoxConfirm('Are you sure you want to schedule candidate?', {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'PROCEED',
        cancelTitle: 'CANCEL',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(res => {
        if(res == true){
          this.toggleLoading()

          this.scheduleInterview({
            times:this.times,
            uiid:this.uiid,
            timezone:this.timezone,
            lang:this.lang,
            location:this.location,
            interview_type:this.interview_type,
          }).then(() => {
            this.times = []
            this.dates = ''
            this.$bvToast.toast(`Scheduled dates has been set!`, {
              title: 'Notification',
              variant:'success'
            })
            this.toggleLoading()
          })
        }
      })
    },
    onNotifyCandidate(vModalEvt){
      vModalEvt.preventDefault()
      for(var key in this.times){
        for(var _key in this.times[key]['times']){
          if(!this.times[key]['times'][_key]['start_time'] || !this.times[key]['times'][_key]['end_time']){
            alert('Please fill up missing fields (Either missing Start time or End time)')
            return false
          }
        }
      }

      if(this.times.length == 0){
        alert('Please add date')
        return false
      }

      if(this.reSched){
        this.$emit('onClickOk', this.times, vModalEvt)
        return false
      }
      this.$bvModal.msgBoxConfirm('Are you sure want to notify candidate?', {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'warning',
        okTitle: 'NOTIFY CANDIDATE',
        cancelTitle: 'CANCEL',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(res => {
        if(res == true){
          this.toggleLoading()
          this.saveNotifyCandidate({
            times:this.times,
            uiid:this.$parent.$data.uiid,
            timezone:this.timezone,
            location:this.location,
            lang:this.lang,
            interview_type:this.interview_type,
          }).then(() => {
            
            this.$bvToast.toast(this.dates ? `Scheduled dates has been set and a notification to candidate has been sent!` : 'Successfully Saved!', {
              title: 'Notification',
              variant:'success'
            })

            this.times = []
            this.dates = ''
            this.toggleLoading()
            this.$nextTick(() => {
              this.$bvModal.hide('schedule-modal')
            })
          })
        }
      })
    },
    onClear(){
      this.times = []
      this.dates = ''
      this.$bvToast.toast(`Clearing dates does'nt mean you deleted them, please click save to apply changes.`, {
        title: 'Warning',
        variant:'warning'
      })
    },
    onRejectCandidate(){
      
    },
    async selectDate(a, b){
      var datesArray =[]

      if(b != ''){
        datesArray = b.split(',').map(function(a){return a.trim()}).sort((a, b) => new Date(a) - new Date(b)) || []
      }

      /* this.times = [] */
      for(var key in datesArray){
        var exists = false;
        for(var tkey in this.times){
          if(this.times[tkey]['date'] == datesArray[key]){
            exists = true
          }
        } 
        if(!exists){
          this.times.push({
            uiid:this.$uuid.v1(),
            date:datesArray[key],
            times:[
              {
                suggestion: this.reSched == true,
                uiid:this.$uuid.v1(),
                start_time:null,
                end_time:null,
              }
            ]
          })
        }
      }

      //delete missing on times
      for(tkey in this.times){
        exists = false;
        for(key in datesArray){
          if(this.times[tkey]['date'] == datesArray[key]){
            exists = true
          }
        }
        if(!exists){
          if(this.times[tkey]._id){
            await this.removeScheduleInterviewByDate(this.times[tkey])
          }
          this.times.splice(tkey, 1)
        }
      }


      this.times = this.times.sort((a, b) => new Date(a.date) - new Date(b.date)) 

      /* this.times.push({
        uiid:this.$uuid.v1(),
        date:datesArray[key],
        start_time:null,
        end_time:null,
      }) */

    }
  },
}
</script>

<style lang="scss">
 .picker-container{
   display: flex;
    justify-content: center;
    .flatpickr-calendar{
      border: none !important;
      .flatpickr-month{
        background: #f8f9fa;
      }
      .flatpickr-days{
        background: #f8f9fa;
      }
    }
    .flatpickr-disabled{
      color: #d2d2d2 !important;
    }
 }
 
</style>